import { render } from "./Pula.vue?vue&type=template&id=49cd8ab8"
import script from "./Pula.vue?vue&type=script&lang=js"
export * from "./Pula.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/src/Microfrontends/devices/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__